import React from "react";
import { ExportOutlined } from "@ant-design/icons";
import { LinkPreviewCard, LinkPreviewStatus, useLinkPreview } from "../../../components/LinkPreviewField";

/** A challenge day's insight link in the phone preview: the design's card, or the old "Learn more" link. */
export function InsightLinkPreview({ link, initialPreview }) {
  const { status, preview } = useLinkPreview(link, initialPreview);
  if (status === "ready" || status === "loading") {
    return <LinkPreviewCard className="challenge-link-preview" status={status} preview={preview} />;
  }
  if (!link) return null;
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className="c-primary">
      Learn more
      <ExportOutlined style={{ marginLeft: 5 }} />
    </a>
  );
}

/** One status line under a day's "Insight Link" input. */
export function InsightLinkStatus({ link, initialPreview }) {
  const { status } = useLinkPreview(link, initialPreview);
  return <LinkPreviewStatus className="challenge-link-status" status={status} />;
}
